import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import style from "./style";
import CustomInput from "../../../../../components/CustomInput";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LoadingButton } from "@mui/lab";
import { addNewUserValidation } from "../../../../../helper/Validation";
import { addUserData } from "../../../../../constants/data";
import { useForm } from "../../../../../hooks/useForm";
import dayjs from "dayjs";
import PhoneInput from "react-phone-input-2";
import { nationalities } from "../../../HRModule/Employees/Edit/data";
import countryList from "react-select-country-list";
import { useNavigate } from "react-router-dom";

const EditStaffPage = () => {
  const [dob, setDob] = useState()
  const [gender, setGender] = useState()
  const [mobile, setMobile] = useState();
  const [cCode, setCCode] = useState()
  const mobileNumberRef = useRef(null);
  const options = countryList().getData();
  const [edit, setEdit] = useState(false)
  const navigate = useNavigate()

  const handleOnChanges = (value,country) => {
    setMobile(value);
    setCCode(country?.dialCode)
  };

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    addUserData,
    addNewUserValidation,
  );
    
  const {
    name,
    idNumber,
    email,
    nationality,
    address,
    city,
    country,
    zipCode,
    department,
    designation,
    employeeID,
  } = state;
  return(
    <Box px="5px" pt="20px">
      <Box px="15px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={style.heading}>{edit ? "Edit Staff" :"View Staff" }</Typography>
                    
        {!edit && <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          <Button variant="contained" color="success" sx={style.checkinBtn} onClick={() =>setEdit(true)}>
            {"Edit Expense"}
          </Button>
                    
        </Box>}
                    
                    
      </Box>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Box>
          <Grid container>
            <Grid item xs={12} sx={style.card}>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    Name<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="name"
                    fullWidth
                    readOnly={!edit}
                    placeholder="Enter Name"
                    value={name?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={name?.error}
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <InputLabel sx={style.label}>Date Of Birth<span style={{ color: "red" }}>*</span></InputLabel>
                    <DatePicker sx={style.dateInput}
                      value={dob}
                      onChange={(newValue) => {setDob(newValue);}}
                      maxDate={dayjs().subtract(16, "year")}
                      readOnly={!edit}
                      slotProps={{
                        field: {
                          readOnly: true
                        }
                      }} />
                  </LocalizationProvider> 
                </Box>
                <Box sx={style.inputBox}>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Typography sx={style.label}>
                          Gender<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={gender || ""}
                      readOnly={!edit}
                      onChange={(event) =>{
                        setGender(event.target.value)
                      }
                      }
                      name="gender"
                      sx={style.dropDownMenu}
                      displayEmpty
                    >
                      <MenuItem disabled value="">
                            Select Gender
                      </MenuItem>
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                
              </Box>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>Email<span style={{ color: "red" }}>*</span></Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    readOnly={!edit}
                    id="email"
                    error={email?.error}
                    placeholder="Enter Email"
                    name="email"
                    value={email?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="email" 
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <FormControl fullWidth sx={style.countryCode}>

                    <Typography sx={style.label}>Phone<span style={{ color: "red" }}>*</span></Typography>
                    <PhoneInput
                      country={"za"}
                      enableSearch={true}
                      value={mobile}
                      defaultValue={cCode}
                      readOnly={!edit}
                      name="mobile"
                      onChange={(value,country)=>handleOnChanges(value,country)}
                      onFocus={handleFocus}
                      ref={mobileNumberRef}
                      error={mobile?.error}
                      sx={style.mobile}
                      inputProps={{
                        readOnly: !edit,
                        style: {
                          height: "1em",
                          borderRadius: "10px",
                          width: "100%",
                          marginTop: "7px",
                        },
                        
                      }}
                  
                    />
                  </FormControl>  
                </Box>              
                
                <Box sx={style.inputBox}>
                  <InputLabel sx={style.label}>
                    ID/Passport Number<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <CustomInput
                    name="amount"
                    fullWidth
                    placeholder="Enter ID"
                    readOnly={!edit}
                    value={idNumber?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    error={idNumber?.error}
                  />
                </Box>
              </Box>
              <Box sx={style.inputSections}>
                <Box sx={style.inputBox}>
                  <FormControl
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.9em",
                        marginTop: "0.5em",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Typography sx={style.label}>Nationality<span style={{ color: "red" }}>*</span></Typography>

                    <Select
                      value={nationality?.value || ""}
                      onChange={(event) => { handleChange("nationality", event.target.value) }}
                      name="nationality"
                      onFocus={handleFocus}
                      readOnly={!edit}
                      sx={style.dropDownMenu}
                    >
                      <MenuItem value="" disabled>Select Nationality</MenuItem>
                      {nationalities?.map((item, index) => (
                        <MenuItem key={index} sx={style.dropDownMenu} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  
                </Box>
                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>Address</Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    readOnly={!edit}
                    id="address"
                    error={address?.error}
                    placeholder="Enter Address"
                    name="address"
                    value={address?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="address" 
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>City</Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    readOnly={!edit}
                    id="city"
                    error={city?.error}
                    placeholder="Enter City"
                    name="city"
                    value={city?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="city" 
                  />
                </Box>
              </Box>
              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <FormControl fullWidth sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "2.8em",
                      marginTop: "0.5em",
                      borderRadius: "10px"
                    }
                  }} >
                    <Typography shrink={true} sx={style.label}>Country <span style={{ color: "red" }}>*</span></Typography>         
                    <Select
                      value={country?.value || ""}
                      onChange={(event) => { handleChange("country", event.target.value)}}
                      name="country"
                      sx={style.dropDownMenu}
                      readOnly={!edit}
                      onFocus={handleFocus}
                      error={country?.error}
                      displayEmpty
                    >
                      <MenuItem disabled value="">Select</MenuItem>
                      {options.map((country, index) => (               
                        <MenuItem key={index} sx={style.dropDownMenu} value={country.label}>{country.label}</MenuItem>
                      ))}                
                    </Select>
                  </FormControl>
                  
                </Box>

                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>Zip Code<span style={{ color: "red" }}>*</span></Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    id="zipCode"
                    readOnly={!edit}
                    error={zipCode?.error}
                    placeholder="Enter Zip Code"
                    name="zipCode"
                    value={zipCode?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="zipCode" 
                  />
                </Box>

                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>Department<span style={{ color: "red" }}>*</span></Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    id="department"
                    readOnly={!edit}
                    error={department?.error}
                    placeholder="Enter Department"
                    name="department"
                    value={department?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="department" 
                  />
                </Box>

              </Box>

              <Box sx={style.inputSection}>
                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>Designation<span style={{ color: "red" }}>*</span></Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    id="designation"
                    error={designation?.error}
                    readOnly={!edit}
                    placeholder="Enter designation"
                    name="designation"
                    value={designation?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="designation" 
                  />
                </Box>
                <Box sx={style.inputBox}>
                  <Typography sx={style.label}>Employee ID<span style={{ color: "red" }}>*</span></Typography>
                  <CustomInput
                    variant="outlined"
                    required
                    fullWidth
                    id="employeeID"
                    error={employeeID?.error}
                    readOnly={!edit}
                    placeholder="Enter Employee ID"
                    name="employeeID"
                    value={employeeID?.value}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    autoComplete="employeeId" 
                  />
                </Box>
                <Box sx={style.inputBox}>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box px={2}>
            <LoadingButton
              variant="contained"
              sx={style.jobButtons}
              type="submit"
            >
              {"Save"}
            </LoadingButton>
            <Button
              onClick={() => navigate("/dashboard/staff")}
              variant="contained"
              sx={style.cancelButtons}
            >
              {"Cancel"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  )
}

export default EditStaffPage